<template>
    <div>
        <q-btn
            label="VIRTUAL GAUGE: EXPERIMENTAL"
            icon-right="mdi-information-outline"
            class="cursor-pointer q-mb-sm"
            color="blue-4"
            data-cy="virtual-gauge-badge"
            @click="showModal=true"
        />
        <q-dialog v-model="showModal">
            <q-card
                class="q-pa-md"
                data-cy="experimental-modal"
            >
                <p>
                    Virtual gauges are an experimental flood forecasting data source provided by
                    <a
                        href="https://sites.research.google/floods"
                        target="_blank"
                    >Google Floodhub</a>.
                </p>

                <p>
                    These gauges display 7 days of streamflow forecasts at a daily resolution, covering approximately 50,000 locations across Canada and the US.
                    Forecasts and alerts are updated daily.
                    Unlike physical gauges, <b>return periods for virtual gauges are currently limited to the 2-year, 5-year, and 20-year streamflow events</b>.
                </p>

                <p>
                    Virtual gauge data is derived from Google's Hydrology Model (not physical hydrometric stations).
                    Please note that virtual gauges are in <b>experimental phase and most virtual gauge data is unverified</b>.
                    Flux Forecast provides virtual data “as is” and does not independently verify the accuracy of individual gauges.
                    <b>Use the virtual gauge data with caution as a supplemental resource</b> to Flux Forecast’s weather forecasts and physical gauges.
                </p>

                <hr>
                <p>
                    For more information on virtual gauges and the forecasting methodology, please visit <a
                        href="https://sites.research.google/gr/floodforecasting/hydrology-model/"
                        target="_blank"
                    >Hydrology model</a>.
                </p>
            </q-card>
        </q-dialog>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const showModal = ref(false);

</script>
